import JSX from "../../helpers/react.js";
import {createElementFromHTML, fileToBlob, uploadImage} from "../../helpers/functions.js";
// import tinymce from '../../helpers/tinymce.min.js';
// tinymce.init()
async function imageUploadHandler(blobInfo: any, progress: (msg: string) => void): Promise<any>{
  const file = blobInfo.blob();
  const buffer = await fileToBlob(file);
  // const blob = new Blob([buffer], {type: file.type})
  const image = await uploadImage(buffer);
  console.log("IMAGE UPLOADED SUCCESSFULLY!!!")
  return (image);

  // Note: To replace the <img> tag’s src attribute with the remote location, please use the success callback defined
  // in the images_upload_handler function with the returned JSON object’s location property.
  // success(json.location);

  // https://www.tiny.cloud/docs/plugins/opensource/image/#exampleusingimages_upload_handler
}
function getStyles(){
  const bodyStyles = getComputedStyle(document.body);
  const styles = Array.from(document.styleSheets)
    .filter(sheet => sheet.href === null || sheet.href.startsWith(window.location.origin))
    .reduce((acc: any, sheet: any) => (acc = [
        ...acc,
        ...Array.from(sheet.cssRules).reduce(
          (def: any, rule: any) =>
            (def = rule.selectorText === ":root" ? [
              ...def,
              ...Array.from(rule.style)
                .filter((name: any) =>
                  name.startsWith("--")
                )
            ] : def), []
        ) as any[]
      ]),
      []
    ) as string[];

  return styles.map(key=>`${key}:${bodyStyles.getPropertyValue(key)}`).join(';');

}
export function initTinyMceEditor(title: string, value: string, onChange: (text: string) => any) {

  tinymce.init({
    selector: '#tiny_mce_editor',
    plugins: [ 'advlist', 'fontsize', 'media', 'editimage', 'autolink', 'link', 'autoresize', 'image', 'hr', 'lists', 'charmap', 'preview' ],
    toolbar_mode: 'floating',
    statusbar: false,
    content_css : '/css/public/tinymce/content.min.css',
    content_style:
      `:root{${getStyles()}};@import url('${location.origin}/fontawesome/css/fontawesome.min.css?2');`,
    skin_url : '/css/public/tinymce/ui',
    menubar: false,
    language: 'ru',
    min_height: 500,
    toolbar_sticky: true,
    toolbar_sticky_offset: 46,
    toolbar: [
      { name: 'styles', items: [ 'fontsize' ] },
      { name: 'image', items: [ 'image' ] },
      { name: 'formatting', items: [ 'bold', 'italic', 'underline', 'strikethrough', 'blockquote' ] },
      { name: 'charmap', items: [ 'hr', 'link' ] },
      { name: 'alignment', items: [ 'alignleft', 'aligncenter', 'alignright', 'alignjustify' ] },
      { name: 'indentation', items: [ 'outdent', 'indent' ] },
      { name: 'bullets', items: [ 'bullist', 'numlist' ] },
    ],
    placeholder: title,
    images_upload_handler: imageUploadHandler,
    setup: function(editor) {
      (window as any).editor = editor;
      editor.on('init', function() {
        editor.setContent(value)
        editor.on("keyup", () => {
          onChange(editor.getContent())
        });
      });
    }
  });
}

export function EditTextBox({name, title}: {name: string, title: string}){
  const dataTextInit = localStorage['text_'+name] || '';

  return (
    <span className="comment-textarea edit-message bordered" data-placeholder={title} contenteditable="true">
            {
              createElementFromHTML(dataTextInit)
            }
        </span>
  );
}
